import type { SpatialLayerOption } from 'components/export-spatial-data';

/**
 * The eval Spatial Data export roster + per-layer attribute catalog (INS-13268). Layer ids mirror
 * the BE `GisExport::Sources::Package::LAYER_KEYS` and each attribute id mirrors that layer's DBF
 * column alias (the second element of `UNIT_COLUMNS` / `ASSET_COLUMNS` / `WELL_STICK_COLUMNS`), so
 * the picker's vocabulary matches exactly what the export writes. Keep in sync with those BE
 * constants when the catalog changes. Order (Slots, Assets, Units) matches the prior layer order.
 *
 * Typed as the shared `SpatialLayerOption[]`, the roster shape the shared SpatialLayerPicker takes,
 * so the Eval 3 modal feeds the shared picker directly. Lives in its own module (not `utils.tsx`) so
 * exporting this non-component constant does not trip `react-refresh/only-export-components` on the
 * component file.
 */
export const SPATIAL_EXPORT_LAYERS: SpatialLayerOption[] = [
  {
    id: 'slots',
    label: 'Slots',
    attributes: [
      { id: 'slot_id', label: 'Slot ID' },
      { id: 'well_name', label: 'Well Name' },
      { id: 'status', label: 'Well Status' },
      { id: 'operator', label: 'Operator' },
      { id: 'hole_dir', label: 'Hole Direction' },
      { id: 'unit', label: 'Unit' },
      { id: 'formation', label: 'Formation' },
      { id: 'basin', label: 'Basin' },
      { id: 'tier', label: 'Tier' },
    ],
  },
  {
    id: 'assets',
    label: 'Assets',
    attributes: [
      { id: 'name', label: 'Name' },
      { id: 'entity', label: 'Entity' },
      { id: 'int_type', label: 'Instrument Type' },
      { id: 'net_acres', label: 'Net Acres' },
      { id: 'gross_acre', label: 'Gross Acres' },
      { id: 'title_qual', label: 'Title Quality' },
      { id: 'title_risk', label: 'Title Risk Factor' },
    ],
  },
  {
    id: 'units',
    label: 'Units',
    attributes: [
      { id: 'name', label: 'Name' },
      { id: 'unit_name', label: 'Unit Name' },
      { id: 'unit_type', label: 'Unit Type' },
    ],
  },
];
